import { render, staticRenderFns } from "./TicketInfo.vue?vue&type=template&id=f7ccb512&scoped=true&"
import script from "./TicketInfo.vue?vue&type=script&lang=js&"
export * from "./TicketInfo.vue?vue&type=script&lang=js&"
import style0 from "./TicketInfo.vue?vue&type=style&index=0&id=f7ccb512&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ccb512",
  null
  
)

export default component.exports